import React from 'react';
import PropTypes from 'prop-types';
import Label from '../atoms/Label';
import Input from '../atoms/Input';
import Text from '../atoms/Text';

/**
 * Form field component that combines label, input, and error message
 */
const FormField = ({ 
  label,
  value,
  onChange,
  type = 'text',
  placeholder = '',
  required = false,
  error = null,
  helpText = null,
  className = '',
  inputClassName = '',
  disabled = false,
  children,
  ...props 
}) => {
  const fieldId = `field-${label?.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <div className={`space-y-1 ${className}`}>
      {/* Label */}
      {label && (
        <Label 
          htmlFor={fieldId}
          required={required}
          className={error ? 'text-red-700' : ''}
        >
          {label}
        </Label>
      )}

      {/* Input or Custom Children */}
      {children ? (
        children
      ) : (
        <Input
          id={fieldId}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          error={!!error}
          className={inputClassName}
          {...props}
        />
      )}

      {/* Error Message */}
      {error && (
        <Text variant="small" className="text-red-600 mt-1">
          {error}
        </Text>
      )}

      {/* Help Text */}
      {helpText && !error && (
        <Text variant="small" className="text-gray-500 mt-1">
          {helpText}
        </Text>
      )}
    </div>
  );
};

FormField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.string,
  helpText: PropTypes.string,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node
};

export default FormField;
